export enum CampaignTypeEnum {
    customer,
    contract
}
